import { render } from "./promotionSummary.vue?vue&type=template&id=c8b70b64&scoped=true"
import script from "./promotionSummary.vue?vue&type=script&lang=js"
export * from "./promotionSummary.vue?vue&type=script&lang=js"

import "./promotionSummary.vue?vue&type=style&index=0&id=c8b70b64&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b70b64"]])

export default __exports__